function postAjax(url, data, success) {
    var params = typeof data == 'string' ? data : [...data.keys()].map(
            function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data.get(k)) }
        ).join('&');

    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open('POST', url);
    xhr.onreadystatechange = function() {
        if (xhr.readyState>3 && xhr.status==200) { success(xhr.responseText); }
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(params);
    return xhr;
}

function validForm(form) {
	let inputs = form.querySelectorAll('input, textarea');
	let formValid = true;
	for (var i = inputs.length - 1; i >= 0; i--) {
		inputs[i].addEventListener('invalid', describeInvalidity)
		let inputValid = inputs[i].checkValidity();
		if ( !inputValid ) { formValid = false; }
	}
	return formValid;
}

function describeInvalidity() {
	this.placeholder = "This field is required.";
}


if (document.getElementById('cta-form')) {
  var submitBtn = document.getElementById('cta-submit');
  var ctaForm = document.getElementById('cta-form');
  submitBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (validForm(ctaForm)) {
    	console.info(ctaForm)
	    grecaptcha.ready(function() {
	      grecaptcha.execute("6Leo1Z4fAAAAAN17vFUqJnd7kic0IxRcrbkI-ium", {action: 'submit'}).then(function(token) {
	        var formData = new FormData(ctaForm)
	        formData.append('recaptcha-token', token)
	        console.log(...formData)
	        if ( document.body.classList.contains("contact") ) {
	          document.getElementById('cta-form').remove();
	          let thanks = document.createElement("h2");
	          thanks.innerText = "Thank you for your submission.";
	          document.getElementById("contact-form-wrap-js").appendChild(thanks);
	        }
	        postAjax('/lumen-form/public/index.php?uri=process-form', formData, function(result) {
	          ctaForm.reset();
	        })
	      });
	    });
    }
  })
}